import { render } from "./Step1.vue?vue&type=template&id=6971b2fc"
import script from "./Step1.vue?vue&type=script&lang=js"
export * from "./Step1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/RuleForm/Start/Step1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6971b2fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6971b2fc', __exports__)) {
    api.reload('6971b2fc', __exports__)
  }
  
  module.hot.accept("./Step1.vue?vue&type=template&id=6971b2fc", () => {
    api.rerender('6971b2fc', render)
  })

}


export default __exports__